import { render, staticRenderFns } from "./uOttawa1321Lab1TLCPlate1V2.vue?vue&type=template&id=0a9be79a&"
import script from "./uOttawa1321Lab1TLCPlate1V2.vue?vue&type=script&lang=ts&"
export * from "./uOttawa1321Lab1TLCPlate1V2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VRow,VTextarea})
